import React, { useContext, useMemo } from "react";
import { Modal, Button, message } from "antd";
import { AuditMarkingContext } from "../context";
import * as actiontypes from "../reducer/action";
import WaterFall from "../FunctionModal/components/WaterFall";
import { rejectAndReAudit, getAuditMarkingGroupIns } from "../../../../api/inspiration"
import "./index.less";

function WatchUpModal(props) {
  const { state, dispatch } = useContext(AuditMarkingContext);
  const onChange = (index, type) => {
    if (type === "choose") {
      state.watchUpModalSource[index].checked =
        !state.watchUpModalSource[index].checked;
      dispatch({
        type: actiontypes.setData,
        data: {
          watchUpModalSource: [...state.watchUpModalSource],
        },
      });
    }
  };
  const reject = async () => {
    const rejectArray = state.watchUpModalSource
      .filter((v) => v.checked)
      .map((v) => v.id);
    if (rejectArray.length <= 0) {
      return message.error("请选择驳回的图片！");
    }
    const groupId = state.groupData.id;
    const data = {
      groupId,
      idList: rejectArray,
    };
    const result = await rejectAndReAudit(data);
    const header = localStorage.getItem("username");
    if (result?.error?.code === 0) {
      message.success("已打回重审！");
      dispatch({
        type: actiontypes.setData,
        data: {
          watchUpModalVisible: false,
          reflashList: true,
          virtualWaterUpdate: true,
          watchUpModalSource: [],
        },
      });
    } else {
      message.error("发生错误！");
    }
  };
  return useMemo(
    () => (
      <>
        <Modal
          visible={state.watchUpModalVisible}
          title={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            ></div>
          }
          footer={null}
          width={1700}
          maskClosable={false}
          onCancel={() => {
            dispatch({
              type: actiontypes.setData,
              data: {
                watchUpModalSource: [],
                watchUpModalVisible: false,
              },
            });
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              marginBottom: 20,
              marginRight: 50,
            }}
          >
            {state.watchUpModel === 1 ? (
              <Button type="danger" onClick={reject}>
                驳回重审
              </Button>
            ) : null}
          </div>
          <WaterFall
            containerWidth={1600}
            itemWidth={246}
            columnCount={6}
            type={1}
            onChange={onChange}
          />
        </Modal>
        <Modal
          visible={state.bigImgModalVisible}
          footer={null}
          wrapClassName="bigImg"
          onCancel={() => {
            dispatch({
              type: actiontypes.setData,
              data: {
                bigImgModalVisible: false,
                bigImgModalSource: "",
              },
            });
          }}
          width={"100%"}
        >
          <img src={state.bigImgModalSource} style={{ maxWidth: 1200 }} />
        </Modal>
      </>
    ),
    [
      state.watchUpModalSource,
      state.bigImgModalSource,
      state.bigImgModalVisible,
      state.watchUpModalVisible,
    ]
  );
}

export default WatchUpModal;
